import { useTranslation } from "react-i18next";

/** WhatsApp contact pill shown across every Dream University step (all
 *  universities). It is positioned by the section into the top-end corner —
 *  right in LTR, left in RTL — sitting in the empty space beside the header. */

const WHATSAPP_NUMBER_DISPLAY = "92272829";
// Kuwait country code (+965) for the wa.me deep link.
const WHATSAPP_LINK = "https://wa.me/96592272829";

export default function WhatsAppContact() {
    const { t } = useTranslation();

    return (
        <a
            href={WHATSAPP_LINK}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={`${t("dream_university_whatsapp_label")} ${WHATSAPP_NUMBER_DISPLAY}`}
            className="group pointer-events-auto inline-flex items-center gap-2.5 rounded-full border border-emerald-100 bg-gradient-to-r from-emerald-50/90 via-white to-white px-2.5 py-1.5 pe-3.5 shadow-sm ring-1 ring-emerald-500/10 backdrop-blur-sm transition-all duration-300 hover:-translate-y-0.5 hover:shadow-md hover:ring-emerald-500/30"
        >
            <span className="relative flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-[#25D366] text-white shadow-sm shadow-emerald-500/40">
                <span className="absolute inset-0 rounded-full bg-[#25D366] opacity-20 animate-ping group-hover:opacity-40" />
                <svg viewBox="0 0 24 24" className="relative h-[18px] w-[18px] fill-current" aria-hidden="true">
                    <path d="M.057 24l1.687-6.163a11.867 11.867 0 01-1.587-5.945C.16 5.335 5.495 0 12.05 0a11.817 11.817 0 018.413 3.488 11.824 11.824 0 013.48 8.414c-.003 6.557-5.338 11.892-11.893 11.892a11.9 11.9 0 01-5.688-1.448L.057 24zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.884a9.86 9.86 0 001.514 5.26l-.999 3.648 3.74-.981a9.86 9.86 0 00.234.174zm5.236-6.273c-.225-.045-.27-.083-.382.075-.112.157-.45.586-.552.706-.102.119-.204.134-.379.045-.175-.09-.739-.272-1.408-.868-.52-.464-.871-1.037-.973-1.212-.102-.175-.011-.27.077-.357.079-.078.175-.204.262-.306.088-.102.117-.175.176-.292.058-.117.029-.219-.015-.306-.044-.087-.394-.949-.539-1.299-.142-.342-.286-.295-.394-.301a7.52 7.52 0 00-.336-.006.644.644 0 00-.467.219c-.16.175-.612.598-.612 1.459 0 .861.627 1.692.714 1.809.087.117 1.232 1.881 2.986 2.638.417.18.743.287.997.368.419.133.8.114 1.101.069.336-.05 1.034-.423 1.18-.831.146-.409.146-.759.102-.832-.043-.073-.16-.117-.335-.205z" />
                </svg>
            </span>
            <span className="flex flex-col items-start leading-tight text-start">
                <span className="hidden text-[13px] font-medium text-gray-500 sm:block">
                    {t("dream_university_whatsapp_label")}
                </span>
                <span
                    className="text-[16.5px] font-extrabold tracking-wide text-emerald-700 transition-colors group-hover:text-emerald-800"
                    dir="ltr"
                >
                    {WHATSAPP_NUMBER_DISPLAY}
                </span>
            </span>
        </a>
    );
}
